import { useState, useEffect } from 'react'
import { getCurrentUser, signOutUser, checkPremiumStatus, onAuthChange } from '../services/firebaseService'
import ThemeToggle from './ThemeToggle'
import '../styles/components/navigation.css'

function Navigation({ currentStep, onNavigate, onAuthRequest, user, hasPremium, onUserChange, onPremiumChange }) {
  const [isScrolled, setIsScrolled] = useState(false)
  const [showMobileMenu, setShowMobileMenu] = useState(false)

  const handleLogout = async () => {
    const result = await signOutUser()
    if (result.success) {
      onUserChange(null)
      onPremiumChange(false)
      window.location.href = '/dist/'
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleNavClick = (path) => {
    setShowMobileMenu(false)
    if (path === 'home') {
      window.location.href = '/dist/'
    } else {
      window.location.href = `/dist/${path}`
    }
  }

  const isLegalPage = ['privacy', 'terms', 'cookie', 'about'].includes(currentStep)
  const isLandingPage = currentStep === 'landing' || !currentStep

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-brand" onClick={() => handleNavClick('home')} role="button" tabIndex={0}>
          <span className="nav-logo">💌</span>
          <span className="nav-title">Parkort</span>
        </div>

        {/* Desktop Menu */}
        <div className="nav-menu">
          {!isLandingPage && (
            <>
              <button 
                className="nav-link" 
                onClick={() => {
                  if (isLegalPage) {
                    window.location.href = '/dist/?step=preferences'
                  } else {
                    onNavigate && onNavigate('preferences')
                  }
                }}
              >
                Lav kort
              </button>
              <button 
                className="nav-link" 
                onClick={() => window.location.href = '/dist/?dashboard=true'}
              >
                📊 Dashboard
              </button>
            </>
          )}
          <a href="/dist/about" className="nav-link">Om</a>
          <a href="/dist/privacy-policy" className="nav-link">Privatliv</a>
          <ThemeToggle />
          {user ? (
            <>
              {hasPremium && (
                <span className="nav-link" style={{ color: 'var(--cyber-blue)', fontSize: '0.9em' }}>
                  ✨ Premium
                </span>
              )}
              <button 
                className="nav-link" 
                onClick={handleLogout}
                style={{ color: 'var(--text-secondary)' }}
              >
                Log ud
              </button>
            </>
          ) : (
            <button 
              className="nav-link nav-cta" 
              onClick={onAuthRequest}
            >
              Log ind
            </button>
          )}
          {isLandingPage && (
            <button 
              className="nav-link nav-cta" 
              onClick={() => onNavigate && onNavigate('preferences')}
            >
              Prøv gratis
            </button>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          aria-label="Toggle menu"
          aria-expanded={showMobileMenu}
        >
          <span className={showMobileMenu ? 'open' : ''}>☰</span>
        </button>
      </div>

      {/* Mobile Menu */}
      {showMobileMenu && (
        <div className="mobile-menu">
          {!isLandingPage && (
            <>
              <button 
                className="mobile-nav-link" 
                onClick={() => {
                  setShowMobileMenu(false)
                  if (isLegalPage) {
                    window.location.href = '/dist/?step=preferences'
                  } else {
                    handleNavClick('home')
                    onNavigate && onNavigate('preferences')
                  }
                }}
              >
                Lav kort
              </button>
              <button 
                className="mobile-nav-link" 
                onClick={() => {
                  setShowMobileMenu(false)
                  window.location.href = '/dist/?dashboard=true'
                }}
              >
                📊 Dashboard
              </button>
            </>
          )}
          <a href="/dist/about" className="mobile-nav-link" onClick={() => setShowMobileMenu(false)}>Om</a>
          <a href="/dist/privacy-policy" className="mobile-nav-link" onClick={() => setShowMobileMenu(false)}>Privatliv</a>
          <div style={{ padding: '12px 16px', display: 'flex', justifyContent: 'center' }}>
            <ThemeToggle />
          </div>
          {user ? (
            <>
              {hasPremium && (
                <span className="mobile-nav-link" style={{ color: 'var(--cyber-blue)' }}>
                  ✨ Premium
                </span>
              )}
              <button 
                className="mobile-nav-link" 
                onClick={() => {
                  setShowMobileMenu(false)
                  handleLogout()
                }}
              >
                Log ud
              </button>
            </>
          ) : (
            <button 
              className="mobile-nav-link mobile-cta" 
              onClick={() => {
                setShowMobileMenu(false)
                onAuthRequest()
              }}
            >
              Log ind
            </button>
          )}
          {isLandingPage && (
            <button 
              className="mobile-nav-link mobile-cta" 
              onClick={() => {
                setShowMobileMenu(false)
                onNavigate && onNavigate('preferences')
              }}
            >
              Prøv gratis
            </button>
          )}
        </div>
      )}
      
      {/* Auth Modal */}</nav>
  )
}

export default Navigation
